import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { UserService } from 'src/app/core/user.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { UserInfoSetApiOutput, User, PermissionActions, BlendEvent } from 'src/app/shared/models';
import { ListItem, MenuComponent, MenuItems, UtilService } from '@material-library';
import { UserRewards } from 'src/app/shared/models';
import { RewardsService } from 'src/app/account/services/rewards.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { ErrCode } from 'src/app/shared/models';
import { ValidateService } from 'src/app/core/validate.service';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ShareService } from 'src/app/shared/services/share.service';
import { BytesToSizePipe } from 'src/app/shared/pipes/bytes-to-size.pipe';
import { BlendService } from 'src/app/shared/services/blend.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
  public user: User;
  public notificationItems: ListItem[] = [];
  private sub: Subscription;
  public showRewardHistoryDialog: boolean = false;
  public showManualRedemptionDialog: boolean = false;
  public showInvalidRedemptionAlert: boolean = false;
  public showNotificationPermissionsDialog: boolean = false;
  public rewardHistoryList: UserRewards;
  public recentRewardHistoryListItems: ListItem[] = [];
  public referralCode: any;
  public errcode: ErrCode;
  public errorMessage: string = '';
  public isErrorState: boolean = false;
  public redemptionError: string;
  public returnCode: number;
  public isButtonLoading: boolean = false;
  public rewardsHistory: any = [];
  public permissionActions = PermissionActions;

  public listItems: ListItem[] = [];
  public recentListItems: ListItem[] = [];
  public previewerProps: ListItem[] = [];
  public previewerOpen: boolean;
  public selectedPreviewValue: string = '';
  public spinner: boolean = false;
  public previewerOptions: any;
  public moreActionsItems: MenuItems[] = [];
  public showAvatarDialog: boolean = false;
  public defaultLogo: string;
  public avatarEndpoint = `${environment.logohost}avatar/saved/`;
  public avatarUrl: string;
  public showNameDialog: boolean = false;
  public showEmailDialog: boolean = false;
  @ViewChild('menuComponent') menuComponent!: MenuComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();

  private bytesToSizePipe: BytesToSizePipe;

  public referenceCode: string;

  constructor(
    private store: Store<fromRoot.State>,
    private snackbarService: SnackbarService,
    private rewards: RewardsService,
    private validateService: ValidateService,
    private api: ApiService,
    private log: LoggerService,
    private userService: UserService,
    private utilService: UtilService,
    private shareService: ShareService,
    private sanitizer: DomSanitizer,
    private blendService: BlendService,
  ) { this.bytesToSizePipe = new BytesToSizePipe(); }

  async ngOnInit(): Promise<void> {
    this.sub = this.store
      .select(fromRoot.getAuthState)
      .subscribe((data) => {
        if (!data.authenticated) {
          this.user = new User();
          // this.initialized = false;
          return;
        }
        if (data.user) {
          this.user = data.user;
          // this.initialized = true;
        }
      });

    this.defaultLogo = this.user.avatar.avatar_data;
    this.avatarUrl = this.defaultLogo ? `${this.avatarEndpoint}${this.user.id}` : '';

    this.shareService.avatarUrl$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(updatedAvatarUrl => {
        this.avatarUrl = updatedAvatarUrl;
      });

    this.moreActionsItems = [
      {
        value: 'change-profile-picture',
        name: 'Change profile picture',
      },
      {
        value: 'change-name',
        name: 'Change name',
      },
      {
        value: 'change-email-address',
        name: 'Change email address',
      }
    ],

    this.notificationItems =
      [
        {
          primaryText: 'Product notifications',
          trail2AdornmentConfig: {
            enabled: true,
            type: 'switch',
            size: 'large',
            switchConfig: {
              size: 'large',
              checked: this.user?.is_emailproduct === 1 ? true : false,
            },
            onChange: async (toggleChange: MatSlideToggleChange) => {
              await this.handleNotificationChange(toggleChange.checked, 'is_emailproduct', 'Product notifications');
            }
          }
        },
        {
          primaryText: 'Special offers',
          trail2AdornmentConfig: {
            enabled: true,
            type: 'switch',
            size: 'large',
            switchConfig: {
              size: 'large',
              checked: this.user?.is_emailmarketing === 1 ? true : false,
            },
            onChange: async (toggleChange: MatSlideToggleChange) => {
              await this.handleNotificationChange(toggleChange.checked, 'is_emailmarketing', 'Special offers');
            }
          }
        },
      ];
    this.selectedPreviewValue = this.user.is_office == 0 ? 'Sync' : this.user.is_office_personal == 1 ? 'Office Online' : 'Office Online for Business',
      this.previewerProps = [
        {
          primaryText: 'Default previewer',
          trail1AdornmentConfig: {
            enabled: true,
            type: 'chip',
            size: 'large',
            chipConfig: {
              label: this.selectedPreviewValue,
              size: 'large',
              readOnly: true
            },
          },
          trail2AdornmentConfig: {
            enabled: true,
            type: 'iconButton',
            size: 'large',
            iconButtonConfig: {
              iconName: 'settings',
              size: 'large',
            },
            onClick: this.openPreviewer
          }
        }];

    this.listItems = [{
      primaryText: 'July 23, 2023',
      secondaryText: 'Referral',
      trail1AdornmentConfig: {
        enabled: true,
        type: 'text',
        size: 'large',
        textContent: '1.0 GB'
      },
    },
    {
      primaryText: 'July 19, 2023',
      secondaryText: 'User Research Program',
      trail1AdornmentConfig: {
        enabled: true,
        type: 'text',
        size: 'large',
        textContent: '100.0 GB'
      },
    },
    {
      primaryText: 'July 11, 2023',
      secondaryText: 'Referral',
      trail1AdornmentConfig: {
        enabled: true,
        type: 'text',
        size: 'large',
        textContent: '1.0 GB'
      },
    }
    ];
    this.recentListItems = this.listItems.reverse();
    this.initPreviewOptions()
    this.rewardHistoryList = await this.rewards.getData();

  }

  openMoreActionsMenu = () => {
    this.menuComponent.openMenu();
  }

  onActionClick(menuItem: MenuItems) {
    if (menuItem?.name === 'Change profile picture') { this.showAvatarDialog = true; }
    if (menuItem?.name === 'Change name') { this.showNameDialog = true; }
    if (menuItem?.name === 'Change email address') { this.showEmailDialog = true; }
  }

  copyReferralLink = async () => {
    try {
      try {
        await navigator.clipboard.writeText(`www.sync.com/?_sync_refer=${this.user.referral_code}`);
        this.snackbarService.showMessage("success", "Link copied.");
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
        this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
      }
    }
    catch (error) {
      console.error('An error occurred while copying the link', error);
      this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
    }
  };

  openRewardHistoryDialog = async () => {
    this.showRewardHistoryDialog = true;
    try {
      const combinedRewards = [
        ...this.rewardHistoryList?.list.map(reward => ({
          primaryText: this.utilService.formatDate(new Date(+reward.bonus_servtime), 'MMM d, y'),
          secondaryText: reward.bonus_type_text,
          trail1AdornmentConfig: {
            enabled: true,
            type: 'text',
            size: 'large',
            textContent: this.bytesToSizePipe.transform(reward.bonus_bytes),
          }
        })),
        ...this.rewardHistoryList?.from_sync.map(reward => ({
          primaryText: this.utilService.formatDate(new Date(+reward.bonus_servtime), 'MMM d, y'),
          secondaryText: reward.bonus_type_text,
          trail1AdornmentConfig: {
            enabled: true,
            type: 'text',
            size: 'large',
            textContent: this.bytesToSizePipe.transform(reward.bonus_bytes),
          }
        }))
      ];
      this.rewardsHistory = combinedRewards.reverse();
    } catch (error) {
      console.error('An error occurred while getting rewards history', error);
    }
  };


  closeRewardHistoryDialog = () => {
    this.showRewardHistoryDialog = false;
  }


  openNotificationPermissionsDialog = () => {
    this.showNotificationPermissionsDialog = true;
  }

  closeNotificationPermissionsDialog = () => {
    this.showNotificationPermissionsDialog = false;
  }

  handleNotificationChange = async (checked: boolean, propertyName: string, name: string) => {
    try {
      const apiInput = {
        [propertyName]: checked ? 1 : 0
      };
      await this.api.execute<UserInfoSetApiOutput>('userinfoset', apiInput);
      this.userService.refresh();
      const statusMessage = checked ? 'turned on.' : 'turned off.';
      this.snackbarService.showMessage('success', name + ' ' + statusMessage);
    } catch (ex) {
      this.snackbarService.showMessage('critical', 'Couldn’t complete action. Try again.')
      // Reverting the original state if an error occurs
      this.notificationItems = this.notificationItems.map(item =>
        item.primaryText === name ? {
          ...item,
          trail2AdornmentConfig: {
            ...item.trail2AdornmentConfig,
            switchConfig: { ...item.trail2AdornmentConfig.switchConfig, checked: !checked }
          }
        } : item
      );
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    } else if (this.unsubscribe$) {
      this.unsubscribe$.unsubscribe();
    }
  }

  openManualRedemptionDialog = () => {
    this.showManualRedemptionDialog = true;
    this.referralCode = '';
    this.errcode = undefined;

  }

  refcode = (value: string) => {
    this.referralCode = value;
    this.redemptionError = '';
    this.showInvalidRedemptionAlert = false;
    if (!this.validateService.isAlphaNumeric(value)) {
      this.redemptionError = 'Referral code must be alphanumeric';
      return;
    } else {
      this.redemptionError = '';
    }
  }

  redeem = async () => {
    this.isButtonLoading = true;
    try {
      await this.api?.execute('rewardclaim', { referrer_code: this.referralCode });
      this.blendService.track(BlendEvent.REWARD_REDEEMED, {method: 'manual'})
      this.rewardHistoryList = await this.rewards.getData();
      this.snackbarService.showMessage("success", "Redemption successful.");
      this.isButtonLoading = false;
      this.closeManualRedemptionDialog();
    } catch (err) {
      this.isButtonLoading = false;
      console.warn('error redeem', err);
      if (err instanceof ErrCode) {
        this.errcode = ErrCode.fromException(err);
        this.showManualRedemptionDialog = true;
        this.showInvalidRedemptionAlert = true;
        this.redemptionError = "Enter a valid referral code";
      } else {
        this.errcode = ErrCode.fromException(err);
        this.errcode = err;
        this.closeManualRedemptionDialog();
        this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
      }
    }
  }

  closeManualRedemptionDialog = () => {
    this.showManualRedemptionDialog = false;
    this.showInvalidRedemptionAlert = false;
    this.redemptionError = '';
  }

  isRedeemButtonDisabled() {
    return !this.referralCode || this.redemptionError !== '';
  }

  openPreviewer = () => {
    this.previewerOpen = true;
    this.initPreviewOptions();
  }

  changeRadioButtonValue = (event: any) => {
    this.selectedPreviewValue = event.value
  }

  onPreviewSave = () => {
    this.save();
  }

  onPreviewClose = () => {
    this.previewerOpen = false;
  }

  initPreviewOptions = () => {
    this.previewerOptions = [
      {
        label: "Sync",
        value: "Sync",
        disabled: false,
        name: "is_office",
        id: "office-pref-product-disable",
        isChecked: this.user.is_office == 0
      },
      {
        label: "Office Online",
        value: "Office Online",
        disabled: false,
        name: "is_office_personal",
        id: "office-pref-product-enable",
        isChecked: this.user.is_office == 1 && this.user.is_office_personal == 1,
      },
      {
        label: "Office Online for Business",
        value: "Office Online for Business",
        disabled: false,
        name: "is_office_business",
        id: "office-pref-product-enable",
        isChecked: this.user.is_office == 1 && this.user.is_office_personal == 0,
      }
    ];
  }

  async save() {
    this.spinner = true;
    const payload = {
      "is_office": this.selectedPreviewValue == 'Sync' ? 0 : 1,
      "is_displayedofficeoptin": 1,
      "is_office_personal": this.selectedPreviewValue == 'Office Online' ? 1 : 0
    }
    try {
      await this.api.execute<UserInfoSetApiOutput>('userinfoset', payload);
      await this.userService.refresh(); // Trigger user data refresh
      this.previewerProps[0].trail1AdornmentConfig.chipConfig.label = this.selectedPreviewValue;
      this.snackbarService.showMessage("success", "Default previewer updated.");
      this.onPreviewClose();
    } catch (error) {
      this.initPreviewOptions();
      this.onPreviewClose();
      this.snackbarService.showMessage("critical", "Couldn't complete action. Try again.");
    } finally {
      this.spinner = false;
    }
  }

  public checkPermission(permName: PermissionActions): boolean {
    return this.userService.checkPermission(permName);
  }
}

